import { generatePath, Navigate, useNavigate, useParams } from 'react-router-dom';

import { PortfolioPaths } from '../../../portfolio.router';
import { SpaceEditModal } from '../components/space-edit-modal.component';

export const SpaceEditRoute = () => {
  const { buildingId, spaceId, discriminator } = useParams<{ buildingId: string, spaceId: string, discriminator: string }>();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  const handleAfterSubmit = () => {
    navigate(generatePath(PortfolioPaths.Space, { buildingId, spaceId, discriminator }), { replace: true });
  }

  if (spaceId == null) {
    return (
      <Navigate to={generatePath(PortfolioPaths.Building, { buildingId })} replace />
    )
  }

  return (
    <SpaceEditModal
      open
      onAfterSubmit={handleAfterSubmit}
      onClose={handleClose}
    />
  )

};
